import { render, staticRenderFns } from "./FeesArea.vue?vue&type=template&id=ae32b03c&scoped=true&"
import script from "./FeesArea.vue?vue&type=script&lang=js&"
export * from "./FeesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae32b03c",
  null
  
)

export default component.exports